// please uncomment on main.ts import of composition api
import VueCompositionAPI from '@vue/composition-api';
import Vue from 'vue';

Vue.use(VueCompositionAPI);
